"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ModalWrapper = _interopRequireDefault(require("../ModalWrapper"));

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var GenericModal = function GenericModal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      closeHandler = _ref.closeHandler,
      dataTestId = _ref.dataTestId,
      hideTopBar = _ref.hideTopBar,
      isOpen = _ref.isOpen,
      title = _ref.title,
      _inStyleGuide = _ref._inStyleGuide,
      props = _objectWithoutProperties(_ref, ["children", "className", "closeHandler", "dataTestId", "hideTopBar", "isOpen", "title", "_inStyleGuide"]);

  return /*#__PURE__*/_react.default.createElement(_ModalWrapper.default, _extends({
    _inStyleGuide: _inStyleGuide,
    className: className,
    closeHandler: closeHandler,
    dataTestId: dataTestId,
    isOpen: isOpen,
    title: title,
    topBar: !hideTopBar
  }, props), children);
};

GenericModal.propTypes = {
  /** Class override */
  className: _propTypes.default.string,

  /** method to invoke as a close handler */
  closeHandler: _propTypes.default.func.isRequired,

  /** Children can be any valid node or array of valid nodes */
  children: _propTypes2.default.children,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** control flag for display */
  isOpen: _propTypes.default.bool,

  /** title of the modal.  */
  title: _propTypes.default.string.isRequired,
  hideTopBar: _propTypes.default.bool,

  /** A flag specifically for the styleguide - used to turn off fixed positioning */
  _inStyleGuide: _propTypes.default.bool
};
GenericModal.defaultProps = {
  className: '',
  children: [],
  hideTopBar: false,
  isOpen: false,
  _inStyleGuide: false
};
var _default = GenericModal;
exports.default = _default;